/*  ========================================================================
    # Scripts - Images with Button
    ========================================================================  */

const ImagesWithButton = {
  cfg: {
    sections: document.querySelectorAll('.s-images-with-button')
  },

  /**
   * Create lightbox elements.
   *
   * @param {Object} section - The section object.
   */
  createLightbox(section) {
    const lightbox = document.createElement('div');
    lightbox.classList.add('s-images-with-button__lightbox');
    lightbox.innerHTML = `
      <button class="s-images-with-button__lightbox-close" type="button" aria-label="Lightbox schließen">
        <span></span>
        <span></span>
      </button>
      <div class="s-images-with-button__lightbox-content">
        <figure class="s-images-with-button__lightbox-image">
          <img src="" alt="">
        </figure>
      </div>
    `;
    section.appendChild(lightbox);

    return {
      lightbox,
      lightboxImage: lightbox.querySelector('.s-images-with-button__lightbox-image img'),
      lightboxCloseButton: lightbox.querySelector('.s-images-with-button__lightbox-close')
    };
  },

  /**
   * Handle lightbox functionality.
   *
   * @param {Object} section - The section object.
   */
  handler(section) {
    // Create lightbox only once.
    const lightboxElements = this.createLightbox(section.section);
    const { lightbox, lightboxImage, lightboxCloseButton } = lightboxElements;

    // Open lightbox when clicking on an image button.
    section.buttons.forEach(button => {
      button.addEventListener('click', () => {
        const img = button.querySelector('img');
        if (img) {
          lightboxImage.setAttribute('src', img.getAttribute('src'));
          lightboxImage.setAttribute('alt', img.getAttribute('alt'));
          lightbox.classList.add('s-images-with-button__lightbox--active');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Close lightbox when clicking the close button.
    lightboxCloseButton.addEventListener('click', () => {
      lightbox.classList.remove('s-images-with-button__lightbox--active');
      document.body.style.overflow = '';
    });

    // Close lightbox when clicking outside the image.
    lightbox.addEventListener('click', event => {
      if (event.target === lightbox) {
        lightbox.classList.remove('s-images-with-button__lightbox--active');
        document.body.style.overflow = '';
      }
    });

    // Close lightbox with escape key.
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && lightbox.classList.contains('s-images-with-button__lightbox--active')) {
        lightbox.classList.remove('s-images-with-button__lightbox--active');
        document.body.style.overflow = '';
      }
    });
  },

  /**
   * Creates an object for each section on the current page.
   */
  sections() {
    this.cfg.sections.forEach(section => {
      const sectionObject = {
        section,
        buttons: section.querySelectorAll('.s-images-with-button__entry-button')
      };

      this.handler(sectionObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections) this.sections();
  }
};

export default ImagesWithButton;
